/**
 * component ลายเซ็นต์
 */
import React, { useState, useEffect, useRef, onMounted } from 'react'
import { Tag, Button, Modal, Popconfirm, message, Image } from 'antd'
import {
  CameraOutlined,
  CheckCircleOutlined,
  ClearOutlined,
  CloseCircleOutlined,
  SaveOutlined,
  SendOutlined,
} from '@ant-design/icons'
import SignaturePad from 'react-signature-canvas'
import styles from './style.scss'
import { Observer } from 'mobx-react'
import { JobService } from '../../../services'
import InformStore from '../../../stores/InformStore'
import { strlimit, generateString } from './../../../helpers/nstring'
import { Moment } from '../../../helpers'
import { JobImageUpload } from '../JobImageUpload'

export const JobSignature = (props) => {
  const [trimmedDataURL, setTrimmedDataURL] = useState()
  const [savedData, setSavedData] = useState()
  const [visibleModalUpload, setVisibleModalUpload] = useState(false)
  const [defaultActiveKey, setDefaultActiveKey] = useState(false)
  let sigPad = {}
  const job = props.job
  

  const clear = () => {
    if (sigPad !== undefined) {
      sigPad.clear()
    }
    setTrimmedDataURL(null)
  }

  const trim = () => {
    setTrimmedDataURL(sigPad.getTrimmedCanvas().toDataURL('image/png'))
  }

  const saveSignature = async () => {
    if (!sigPad.isEmpty()) {
      const dataSig = sigPad.getTrimmedCanvas().toDataURL('image/png')
      if (dataSig) {
        await fetch(dataSig)
          .then((rs) => rs.arrayBuffer())
          .then((buf) => {
            const file = new File(
              [buf],
              props.job.id + '_' + generateString(24) + '.png',
              {
                type: 'image/png',
              },
            )
            let formData = new FormData()
            formData.append('model_id', props.job.id)
            formData.append('model_type', 'informjob_signature_customer')
            formData.append('files', file)
            // upload signature
            JobService.uploadSingnature(props.job.id, formData)
              .then(({ data }) => {
                if (data) {
                  message.success(data.message)
                  if (props.onSave) props.onSave(data.data)
                }
              })
              .catch((err) => {
                console.log('err', err)
                message.error(err.response.statusText)
              })
          })
      }
    }

    // changae status to complete job
    // if (props.canSendJob) {
    //   JobService.sendJob(job.id)
    //     .then(({ data }) => {
    //       if (data) {
    //         InformStore.setJob(data.data)
    //         message.success(data.message)
    //         if (props.onSave) props.onSave(data.data)
    //       }
    //     })
    //     .catch((err) => {
    //       console.log('err', err)
    //     })
    // }
  }

  const sendJob = () => {
    if (props.canSendJob) {
      JobService.sendJob(job.id)
        .then(({ data }) => {
          if (data) {
            InformStore.setJob(data.data)
            message.success(data.message)
            if (props.onSendJob) props.onSendJob(data.data)
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    }
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window
    return { width, height }
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions(),
    )

    useEffect(() => {
      const handleResize = () => setWindowDimensions(getWindowDimensions())

      window.addEventListener('resize', handleResize)

      return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
  }
  const { width } = useWindowDimensions()
  document.addEventListener(
    'touchmove',
    function(event) {
      if (event.scale !== 1) {
        event.preventDefault()
      }
    },
    { passive: false },
  )

  return (
    <>
      <Observer key={`ob${job.id}`}>
        {() => {
          return (
            <>
              <Modal
                key={`modal${props.job.id}`}
                title={
                  props.job
                    ? `#${props.job.id} | บันทึกลายเซ็นต์ลูกค้า/ส่งงาน`
                    : 'บันทึกลายเซ็นต์'
                }
                open={props.visible}
                onCancel={() => {
                  props.onClose()
                }}
                width={650}
                style={{
                  top: 0,
                  bottom: 0,
                }}
                footer={[
                  <span
                    style={{ color: 'red', textAlign: 'left', marginRight: 5 }}
                    key={`text_description__${props.job.id}`}
                  >
                    โทรศัพท์มือถือ ควรหมุนหน้าจอเป็นแนวนอน
                  </span>,

                  job && !job.signatureCustomer ? (
                    <Button
                      type="danger"
                      key={`clear__${props.job.id}`}
                      onClick={() => clear()}
                      size="small"
                      icon={<ClearOutlined />}
                    >
                      เคลียร์
                    </Button>
                  ) : (
                    ''
                  ),
                  <Button
                  type='primary'
                  key={`camera__${props.job.id}`}
                  onClick={() => {
                    setVisibleModalUpload(true)
                  }}
                  icon={<CameraOutlined />}
                  size="small"
                >
                  {' '}
                  1) ถ่ายรูป{' '}
                </Button>,
                  job && !job.signatureCustomer ? (
                    <Popconfirm
                      key={`confirm-save-sig${job.id}`}
                      placement="topRight"
                      title={`ยืนยันบันทึกลายเซ็นต์ ?`}
                      onConfirm={() => {
                        saveSignature()
                      }}
                      okText="ใช่"
                      cancelText="ไม่ใช่"
                    >
                      <Button
                        type="success"
                        key={`savesig__${props.job.id}`}
                        icon={<SaveOutlined />}
                        size="small"
                      >
                        2) เซ็นต์
                      </Button>
                    </Popconfirm>
                  ) : (
                    ''
                  ),
                  job && job.send_job_at < 1 && props.canSendJob ? (
                    <Popconfirm
                      key={`btn-send-job${job.id}`}
                      placement="topRight"
                      title={`ยืนยันส่งงาน ?`}
                      onConfirm={() => {
                        sendJob()
                      }}
                      okText="ใช่"
                      cancelText="ไม่ใช่"
                    >
                      <Button
                        type="primary"
                        key={`btn__sendjob__${props.job.id}`}
                        icon={<SendOutlined />}
                        size="small"
                      >
                        3) ส่งงาน
                      </Button>
                    </Popconfirm>
                  ) : (
                    ''
                  ),

                ]}
              >
                {job.signatureCustomer ? (
                  <>
                    <Image
                      preview={false}
                      src={job.signatureCustomer}
                      key={`img_sig_${job.id}`}
                    />
                    {job.send_job_at > 0 &&
                    Moment.unix(job.send_job_at).isValid()
                      ? Moment.unix(job.send_job_at).format('lll')
                      : ''}
                  </>
                ) : (
                  <>
                    <div className="">
                      <div className="sigContainer">
                        <SignaturePad
                          canvasProps={{
                            width: 640,
                            height: 220,
                            className: 'sigPad',
                          }}
                          redrawOnResize
                          clearOnResize
                          ref={(ref) => {
                            sigPad = ref
                          }}
                          penColor="blue"
                          onEnd={(d) => {
                            trim()
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* <img src={trimmedDataURL}/> */}
              </Modal>
              
        {visibleModalUpload ? (
          <>
            {' '}
            <JobImageUpload
              jobId={job.id}
              visible={visibleModalUpload}
              onUpload={(data) => {
                this.setState({
                  defaultActiveKey: 'image',
                })
                // console.log('active', this.state.defaultActiveKey)
                console.log('on upload', data)
                setTimeout(() => setVisibleModalUpload(false), 500)
              }}
              onCancel={() => {
                // this.getJob(job.id)
                // console.log('active', this.state.defaultActiveKey)
                setTimeout(() => setVisibleModalUpload(false), 500)
              }}
            />
          </>
        ) : (
          ''
        )}
            </>
          )
        }}
      </Observer>
    </>
  )
}
